(() => {
  const SUMMARY_STATE_KEY = '__cartDrawerV2SummaryState';
  const INSTANCE_KEY = '__cartDrawerV2Summary';

  if (window[INSTANCE_KEY]) {
    return;
  }

  class CartDrawerV2Summary {
    constructor() {
      this.handleCartUpdate = this.handleCartUpdate.bind(this);
      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.state = window[SUMMARY_STATE_KEY] || { detailsOpen: false };
      window[SUMMARY_STATE_KEY] = this.state;
    }

    mount() {
      document.addEventListener('liquid-ajax-cart:queue-end', this.handleCartUpdate);
      document.addEventListener('cart:updated', this.handleCartUpdate);
      document.addEventListener('click', this.handleDocumentClick);
      this.sync();
    }

    handleCartUpdate() {
      this.sync();
    }

    handleDocumentClick(event) {
      const toggle = event.target.closest('.cart-drawer-v2__totals__total__toggle');

      if (!toggle) {
        return;
      }

      window.requestAnimationFrame(() => {
        const details = document.querySelector('#CartDrawerV2 .cart-drawer-v2__totals__details');
        this.state.detailsOpen = details ? !details.classList.contains('hidden') : false;
      });
    }

    sync() {
      const cartDrawer = document.querySelector('#CartDrawerV2');

      if (cartDrawer) {
        this.restoreDetailsState(cartDrawer);
      }

      const cart = this.getCart();

      if (!cart) {
        return;
      }

      if (cartDrawer) {
        this.updateFinanceSummary(cartDrawer, cart);
      }
    }

    getCart() {
      return window.liquidAjaxCart?.getState?.()?.cart || window.liquidAjaxCart?.cart || null;
    }

    getThemeState() {
      return window.__Theme?._ctx?.getState?.() || null;
    }

    restoreDetailsState(cartDrawer) {
      const details = cartDrawer.querySelector('.cart-drawer-v2__totals__details');
      const showDetails = cartDrawer.querySelector('.cart-drawer-v2__totals__total__toggle .show-details');
      const hideDetails = cartDrawer.querySelector('.cart-drawer-v2__totals__total__toggle .hide-details');

      if (!details || !showDetails || !hideDetails) {
        return;
      }

      details.classList.toggle('hidden', !this.state.detailsOpen);
      showDetails.classList.toggle('hidden', this.state.detailsOpen);
      hideDetails.classList.toggle('hidden', !this.state.detailsOpen);
    }

    /**
     * Keeps the finance line under the cart total in step with the cart.
     *
     * The maths lives in _src/scripts/lib/Finance.js (exposed as window.radiant.finance) so the
     * drawer, the PDP block and the calculator popup can't drift apart. radiant.js is deferred,
     * so on the very first sync it may not be there yet - the Liquid render is already correct
     * at that point, and the next cart update picks it up.
     */
    updateFinanceSummary(cartDrawer, cart) {
      const finance = window.radiant?.finance;
      const financeWrapper = cartDrawer.querySelector('.cart-drawer-v2__totals__finance');
      const financePrice = financeWrapper?.querySelector('.finance-price');
      const trigger = financeWrapper?.querySelector('[data-finance-block-price]');

      if (!finance || !financeWrapper || !financePrice) {
        return;
      }

      const totalPrice = Number(cart.total_price || 0);
      const best = finance.best(totalPrice);

      financeWrapper.classList.toggle('hidden', !best);

      // Carried on the trigger so the calculator popup opens on the current cart total
      if (trigger) {
        trigger.setAttribute('data-finance-block-price', Math.round(totalPrice));
      }

      if (!best) {
        return;
      }

      financePrice.textContent = `${finance.formatMoney(best.monthly)}/month`;
    }

    formatMoney(cents) {
      if (window.Shopify?.formatMoney) {
        const moneyFormat = Number(cents || 0) % 100 === 0
          ? '£{{amount_no_decimals}}'
          : (this.getThemeState()?.moneyFormat || window.Shopify.money_format || '£{{amount}}');

        return window.Shopify.formatMoney(cents, moneyFormat);
      }

      const value = (Number(cents || 0) / 100).toFixed(2);
      const [whole, fraction] = value.split('.');
      const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

      return fraction === '00' ? `£${formattedWhole}` : `£${formattedWhole}.${fraction}`;
    }
  }

  const summary = new CartDrawerV2Summary();
  window[INSTANCE_KEY] = summary;
  summary.mount();
})();
